const LOCATION = {

  id: "location",
  type: "dropdown",
  props: {
    isMulti: true,
    dropdownProps: {
      label: "Location",
      buttonProps: {
        className: "location",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "D1 - Boat Quay / Raffles Place / Marina", value: "D01" },
      { label: "D2 - Chinatown / Tanjong Pagar", value: "D02" },
      { label: "D3 - Alexandra / Commonwealth", value: "D03" },
      { label: "D4 - Sentosa / Harbourfront", value: "D04" },
      { label: "D5 - Buona Vista / West Coast / Clementi", value: "D05" },
      { label: "D6 - City Hall / Clarke Quay", value: "D06" },
      { label: "D7 - Beach Road / Bugis / Rochor", value: "D07" },
      { label: "D8 - Farrer Park / Serangoon Rd", value: "D08" },
      { label: "D9 - Orchard / River Valley", value: "D09" },
      { label: "D10 - Tanglin / Holland / Bukit Timah", value: "D10" },
      { label: "D11 - Newton / Novena", value: "D11" },
      { label: "D12 - Balestier / Toa Payoh", value: "D12" },
      { label: "D13 - Macpherson / Potong Pasir", value: "D13" },
      { label: "D14 - Eunos / Geylang / Paya Lebar", value: "D14" },
      { label: "D15 - East Coast / Marine Parade", value: "D15" },
      { label: "D16 - Bedok / Upper East Coast", value: "D16" },
      { label: "D17 - Changi Airport / Changi Village", value: "D17" },
      { label: "D18 - Pasir Ris / Tampines", value: "D18" },
      { label: "D19 - Hougang / Punggol / Sengkang", value: "D19" },
      { label: "D20 - Ang Mo Kio / Bishan / Thomson", value: "D20" },
      { label: "D21 - Clementi Park / Upper Bukit Timah", value: "D21" },
      { label: "D22 - Boon Lay / Jurong / Tuas", value: "D22" },
      { label: "D23 - Dairy Farm / Bukit Panjang / Choa Chu Kang", value: "D23" },
      { label: "D24 - Lim Chu Kang / Tengah", value: "D24" },
      { label: "D25 - Admiralty / Woodlands", value: "D25" },
      { label: "D26 - Mandai / Upper Thomson", value: "D26" },
      { label: "D27 - Sembawang / Yishun", value: "D27" },
      { label: "D28 - Seletar / Yio Chu Kang", value: "D28" }
    ]
  }

}

const COL_LOCATION = {

  id: "col_location",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [LOCATION]

}

const COL_MODAL_LOCATION = {

  id: "col_location",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [LOCATION]

}

export { LOCATION, COL_LOCATION, COL_MODAL_LOCATION };
